import { darken } from '@savgroup-front-common/primitive/helpers/cssColor';
import { rem } from '@savgroup-front-common/primitive/helpers/units';
import { SUPPORTED_PROPERTIES } from '@savgroup-front-common/types';

export default {
  [SUPPORTED_PROPERTIES.COLOR]: {
    fallback: 'colors.white',
  },
  [SUPPORTED_PROPERTIES.BACKGROUND_COLOR]: {
    fallback: 'colors.primary',
  },
  [SUPPORTED_PROPERTIES.ON_HOVER_BACKGROUND_COLOR]: {
    value: darken(0.075, '#205DF3'),
  },
  [SUPPORTED_PROPERTIES.DISABLED_COLOR]: {
    fallback: 'colors.disabled',
  },
  [SUPPORTED_PROPERTIES.DISABLED_BACKGROUND_COLOR]: {
    fallback: 'colors.disabled',
  },
  [SUPPORTED_PROPERTIES.TEXT_TRANSFORM]: {
    value: 'inherit',
  },
  [SUPPORTED_PROPERTIES.PADDING]: {
    value: `${rem(14)} ${rem(21)}`,
  },
  [SUPPORTED_PROPERTIES.FONT_WEIGHT]: {
    value: 500,
  },
};
